import axios from 'axios';
import { apiUrl } from '../env';
import {
  SQLoyaltyProgram,
  TTLoyalty,
  TTLoyaltyRegisterRequest,
} from '../interfaces/loyalty';
import { getAuthHeaders } from './utils';
/* eslint-disable */
export const loyaltyApi = {
  async getMerchantProgram(merchant_ids: number[]) {
    return axios.get<SQLoyaltyProgram[]>(
      `${apiUrl}/api/v1/loyalty/merchant-loyalty-programs?${merchant_ids
        .map(i => 'merchant_ids=' + i.toString())
        .join('&')}`,
      {
        headers: await getAuthHeaders(),
      },
    );
  },
  async getCustomerLoyaltyAccount(
    phone_number: string | null,
    card_fingerprint: string | null,
    merchant_ids: number[],
  ) {
    return axios.get<TTLoyalty[]>(
      `${apiUrl}/api/v1/loyalty/?phone_number=${encodeURIComponent(
        phone_number,
      )}&card_fingerprint=${card_fingerprint}&${merchant_ids
        .map(i => 'merchant_ids=' + i.toString())
        .join('&')}`,
      {
        headers: await getAuthHeaders(),
      },
    );
  },
  async registerForLoyalty(obj_in: TTLoyaltyRegisterRequest) {
    return axios.post<TTLoyalty[]>(
      `${apiUrl}/api/v1/loyalty/in-person/register`,
      obj_in,
      {
        headers: await getAuthHeaders(),
      },
    );
  },
};
